import { render, staticRenderFns } from "./ShelfList.vue?vue&type=template&id=7dfb5b8a&scoped=true&"
import script from "./ShelfList.vue?vue&type=script&lang=js&"
export * from "./ShelfList.vue?vue&type=script&lang=js&"
import style0 from "./ShelfList.vue?vue&type=style&index=0&id=7dfb5b8a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dfb5b8a",
  null
  
)

export default component.exports